// Equipo (solo ADMIN): personas del panel, su rol y sus contraseñas temporales.
import type { Role, TemporaryPasswordView, UserView } from '@hilo/contracts';
import { api } from './api';

export const createUser = (body: { email: string; displayName: string; role: Role }) =>
  api<TemporaryPasswordView>('POST', '/users', { body });
export const updateUser = (id: string, body: { displayName?: string; role?: Role; active?: boolean }) =>
  api<UserView>('PATCH', `/users/${id}`, { body });
export const resetUserPassword = (id: string) => api<TemporaryPasswordView>('POST', `/users/${id}/reset-password`);

export const ROLE_LABEL: Record<Role, string> = { ADMIN: 'Administración', SUPERVISOR: 'Supervisión', AGENT: 'Atención' };

/** Qué puede hacer cada rol, dicho como lo vive la persona (mismas reglas que la API). */
export const ROLE_HELP: Record<Role, string> = {
  AGENT: 'Atiende las conversaciones de las cuentas a las que le des acceso.',
  SUPERVISOR: 'Atiende sus cuentas y además reasigna y cambia el estado de cualquier conversación de ellas.',
  ADMIN: 'Ve todas las cuentas y gestiona Conexiones y el equipo.',
};

/** Orden en pantalla: de quien gestiona a quien atiende. */
export const ROLE_ORDER: Role[] = ['ADMIN', 'SUPERVISOR', 'AGENT'];
